import { render, staticRenderFns } from "./loginV2.vue?vue&type=template&id=60d2195c&scoped=true&"
import script from "./loginV2.vue?vue&type=script&lang=js&"
export * from "./loginV2.vue?vue&type=script&lang=js&"
import style0 from "./loginV2.vue?vue&type=style&index=0&id=60d2195c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2195c",
  null
  
)

export default component.exports